module.exports = __webpack_public_path__ + "static/media/group-33@3x.4b091315.png";